import React, {useContext, useEffect, useMemo, useState} from 'react'
import {Button, Stack} from '@mui/material'
import {useSelector} from 'react-redux'
import {selectChartPanes} from '../../../selectors/chart'
import {ChartContext} from '../chart.context'
import {NonInteractiveTooltip} from '../../custom'
import BinIcon from '../../../assets/icons/BinIcon'
import ThinArrowUpwardIcon from "../../../assets/icons/ThinArrowUpwardIcon";
import ThinArrowDownwardIcon from "../../../assets/icons/ThinArrowDownwardIcon";

interface ChartPaneActionsProps {
    primary: boolean;
    index: number;
}

const ChartPaneActions: React.FC<ChartPaneActionsProps> = (props) => {
    const chartContext = useContext(ChartContext)
    const {viewKey, chart, hoveredPaneId} = chartContext!
    const {index, primary} = props
    const panes = useSelector(selectChartPanes(viewKey))
    const totalPanes = useMemo(() => panes.length, [panes])
    const [chromeHover, setChromeHover] = useState(false)
    const chartTargetsPane = hoveredPaneId === index
    const showActions = chartTargetsPane || chromeHover

    useEffect(() => {
        if (hoveredPaneId !== undefined && hoveredPaneId !== index) {
            setChromeHover(false)
        }
    }, [hoveredPaneId, index])
    const iconStyle = {
        fontSize: '16px',
        margin: '0',
        color: 'inherit'
    }

    const onMoveUp = (index: number) => {
        chart.swapPanes(index - 1, index)
    }

    const onMoveDown = (index: number) => {
        chart.swapPanes(index, index + 1)
    }

    const onRemoveClicked = (index: number) => {
        chart.removePane(index)
    }

    return showActions ? (
        <Stack
            direction={'row'}
            gap={0.5}
            style={{position: 'absolute', top: 4, right: 12, zIndex: '3'}}
            onMouseEnter={() => setChromeHover(true)}
            onMouseLeave={() => setChromeHover(false)}
        >
            {index !== 0 && (
                <NonInteractiveTooltip placement={'top'} title={'Move pane up'}>
                    <Button sx={{padding: '4px !important', minWidth: 'auto'}} onClick={() => onMoveUp(index)}
                            variant="outlined" size="small" color={'inherit'}>
                        <ThinArrowUpwardIcon style={iconStyle}/>
                    </Button>
                </NonInteractiveTooltip>
            )}
            {index > 0 && index < totalPanes - 1 && (
                <NonInteractiveTooltip placement={'top'} title={'Move pane down'}>
                    <Button sx={{padding: '4px !important', minWidth: 'auto'}} onClick={() => onMoveDown(index)}
                            variant="outlined" size="small" color={'inherit'}>
                        <ThinArrowDownwardIcon style={iconStyle}/>
                    </Button>
                </NonInteractiveTooltip>
            )}
            {!primary && (
                <NonInteractiveTooltip placement={'bottom'} title={'Delete pane'}>
                    <Button sx={{padding: '4px !important', minWidth: 'auto'}} onClick={() => onRemoveClicked(index)}
                            variant="outlined" size="small" color={'inherit'}>
                        <BinIcon style={iconStyle}/>
                    </Button>
                </NonInteractiveTooltip>
            )}
        </Stack>
    ) : null
}

export default ChartPaneActions